export enum ENotificationId {
    SupportContact = "support-contact",
}

export enum ENotificationBannerTheme {
    Alert = "alert",
    Info = "info",
}
